import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Manage")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("DataPump")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Catalog")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Orders")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("User Tiers")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Reviews")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Login")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("About")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "nav",
      class: _normalizeClass({ 'has-background-black': _ctx.isDark })
    }, [
      _createVNode(_component_router_link, {
        to: "/",
        class: _normalizeClass({ 'has-text-white': _ctx.isDark })
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_2,
      _createVNode(_component_router_link, {
        to: "/manage",
        class: _normalizeClass({ 'has-text-white': _ctx.isDark })
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_4,
      _createVNode(_component_router_link, {
        to: "/datapump",
        class: _normalizeClass({ 'has-text-white': _ctx.isDark })
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_6,
      _createVNode(_component_router_link, {
        to: "/catalog",
        class: _normalizeClass({ 'has-text-white': _ctx.isDark })
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_8,
      _createVNode(_component_router_link, {
        to: "/orders",
        class: _normalizeClass({ 'has-text-white': _ctx.isDark })
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_10,
      _createVNode(_component_router_link, {
        to: "/tiers",
        class: _normalizeClass({ 'has-text-white': _ctx.isDark })
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_12,
      _createVNode(_component_router_link, {
        to: "/reviews",
        class: _normalizeClass({ 'has-text-white': _ctx.isDark })
      }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_14,
      _createVNode(_component_router_link, {
        to: "/login",
        class: _normalizeClass({ 'has-text-white': _ctx.isDark })
      }, {
        default: _withCtx(() => [
          _hoisted_15
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_16,
      _createElementVNode("a", {
        class: _normalizeClass({ 'has-text-white': _ctx.isDark }),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDarkMode && _ctx.toggleDarkMode(...args)))
      }, _toDisplayString(_ctx.darkModeButtonText), 3),
      _hoisted_17,
      _createElementVNode("a", {
        class: _normalizeClass({ 'has-text-white': _ctx.isDark }),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
      }, " Logout ", 2),
      _hoisted_18,
      _createVNode(_component_router_link, {
        to: "/about",
        class: _normalizeClass({ 'has-text-white': _ctx.isDark })
      }, {
        default: _withCtx(() => [
          _hoisted_19
        ]),
        _: 1
      }, 8, ["class"])
    ], 2),
    _createVNode(_component_router_view)
  ], 64))
}